import axios from "axios"
import { flatMap } from "lodash"
import qs from 'querystring'
import AxiosAPIV2 from "../axios"

export default {

  namespaced: true,

  state: {},

  actions: {

    async getList(_, query) {
      const params = { ...query, 'source': 'CHANNEL', 'per_page': 10 }
      try {
        const response = await axios.get(`/orders`, { params })
        return response.data.data
      } catch (o_o) {
        return []
      }
    },

    async getOrder(_, id) {
      try {
        const response = await axios.get(`/orders/${id}`)
        return response.data.data
      } catch (o_o) {
        return null
      }
    },

    async updateOrder(_, {id, comment}) {
      try {
        const response = await axios.put(`/orders/${id}`, {comment})
        return response.data.data
      } catch (o_o) {
        return null
      }
    },

    async getShippingStatus(_, id) {
      try {
        const response = await AxiosAPIV2.get(`/orders/${id}/shipping_status`)
        return response.data
      } catch (o_o) {
        throw o_o
      }
    },

    async autoaddress(_, text) {
      try {
        const response = await AxiosAPIV2.post(`/split_address`, {
        text
        })
        return response.data
      } catch (o_o) {
        console.log("split error", o_o)
        return null
      }
    },

    

    async pay(_, payload) {
      var tradeType = "NATIVE"
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        tradeType = "MWEB"
      }

      if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        if (navigator.userAgent.indexOf("MicroMessenger") > 0) {
          tradeType = "JSAPI"
  
          if (localStorage.openId) {
            payload.openid = localStorage.openId
          }
        }
      }

      const response = await axios.post(`/pay`, { ...payload, tradeType })
      return response.data.data
    },
  },

  mutations: {

  }

}
